import { ChangeEvent } from 'react';

export const handleOnchange = (
  event: ChangeEvent<HTMLInputElement>,
  min: number | undefined,
  max: number | undefined,
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  name = '',
) => {
  const inputValue = event.target.value;

  // Allow empty input and incomplete decimal input (like "95." or ".")
  if (inputValue === '' || inputValue === '.' || inputValue.endsWith('.')) {
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
      },
    });
    return;
  }

  const value = parseFloat(inputValue);

  // Skip validation if the input is not a valid number (allows partial typing)
  if (isNaN(value)) {
    onChange({
      ...event,
      target: {
        ...event.target,
        name: name,
      },
    });
    return;
  }

  // Only apply min/max validation for complete numeric input
  if (min?.toString() && max?.toString()) {
    if (value <= max && value >= min) {
      onChange({
        ...event,
        target: {
          ...event.target,
          name: name,
        },
      });
      return;
    }
    if (value >= max) {
      event.target.value = max.toString();
      onChange({
        ...event,
        target: {
          ...event.target,
          value: max.toString(),
          name: name,
        },
      });
      return;
    }
    if (value <= min) {
      onChange({
        ...event,
        target: {
          ...event.target,
          value: min.toString(),
          name: name,
        },
      });
      return;
    }
  }
  if (min?.toString() && !max?.toString()) {
    if (value < min) {
      onChange({
        ...event,
        target: {
          ...event.target,
          value: min.toString(),
          name: name,
        },
      });
    } else {
      onChange({
        ...event,
        target: {
          ...event.target,
          name: name,
        },
      });
    }
    return;
  }
  if (max?.toString() && !min?.toString()) {
    if (value > max) {
      onChange({
        ...event,
        target: {
          ...event.target,
          value: max.toString(),
          name: name,
        },
      });
    } else {
      onChange({
        ...event,
        target: {
          ...event.target,
          name: name,
        },
      });
    }
    return;
  }

  // No min/max constraints
  onChange({
    ...event,
    target: {
      ...event.target,
      name: name,
    },
  });
};
